import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchSingleOrderDetailsForCmm } from "../../../redux/slice/cmm/cmmSingleOrderSlice";
import { AppDispatch } from "../../../redux/store/store";

export const useFetchOrderData = (orderId: string | undefined) => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (orderId) {
      dispatch(fetchSingleOrderDetailsForCmm(orderId));
    }
  }, [orderId]);
};
